import { youthDivisionIds } from 'constants/event';

export const isYouthEvent = (eventRank) => {
  return youthDivisionIds.includes(eventRank);
};
